module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/patients/initial-exam.component.css
// module id = ./src/app/views/patients/initial-exam.component.css
// module chunks = main